import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClioConstants } from "../../models/clio-constants/clio-constants";
import { AuthService } from "../auth/auth.service";
import { environment } from "../../../environments/environment";
import { Store } from "@ngrx/store";
import { selectIsOauthTokenValid, selectOauthAccessTokenValue } from "../../stores/auth/auth.selector";
import { AppState } from "../../stores/app.state";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {


  constructor(private authService: AuthService, private store: Store<AppState>) {

  }

  /**
   * Once logged in, every request to clipapi endpoints should contain a token
   * Skip requests to F5 auth/session endpoints
   * Skip request to angular assets
   * */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.name == "DEV") {
      const accessToken = this.store.selectSignal(selectOauthAccessTokenValue)();
      const cloned = request.clone({ headers: request.headers.set(ClioConstants.JWT_TOKEN_HEADER, "Bearer " + accessToken) });
      return next.handle(cloned);
    }
    let oauth2SessionBaseUrl = environment.oauth2SessionBaseUrl;
    const isOauthTokenValid = this.store.selectSignal(selectIsOauthTokenValid)();
    // console.log(request.url)
    // console.log("oauth2SessionBaseUrl?", !request.url.startsWith(oauth2SessionBaseUrl))
    // console.log("assets?", !request.url.includes("assets"))
    // console.log("isOauthTokenValid?", isOauthTokenValid)


    if (!request.url.startsWith(oauth2SessionBaseUrl) && !request.url.includes("assets") && isOauthTokenValid) {
      const accessToken = this.store.selectSignal(selectOauthAccessTokenValue)();
      if (!accessToken) {
        return next.handle(request);
      }
      const cloned = request.clone({ headers: request.headers.set(ClioConstants.JWT_TOKEN_HEADER, "Bearer " + accessToken) });
      return next.handle(cloned);
    } else {
      return next.handle(request);
    }
  }
}
